// src/components/Icon.tsx

import React from 'react';

// Use a namespace import to bring in all 'go' icons under a single object
import * as GoIcons from 'react-icons/go';
// Import icons from other libraries individually
import { CgHello } from 'react-icons/cg';

/**
 * A type-safe map that links string keys to React component types.
 * This is the single source of truth for all icons in the application.
 */
const iconMap: Record<string, React.ElementType> = {
    // Standard 'Go' Icons
    GoHome: GoIcons.GoHome,
    GoPeople: GoIcons.GoPeople,
    GoDatabase: GoIcons.GoDatabase,
    GoInbox: GoIcons.GoInbox,
    GoGear: GoIcons.GoGear,
    GoGraph: GoIcons.GoGraph,
    GoPulse: GoIcons.GoPulse,
    GoQuestion: GoIcons.GoQuestion,
    GoBook: GoIcons.GoBook,
    GoBell: GoIcons.GoBell,
    GoGitBranch: GoIcons.GoGitBranch,
    GoChevronRight: GoIcons.GoChevronRight,
    GoPersonAdd: GoIcons.GoPersonAdd,
    GoServer: GoIcons.GoServer,
    GoFile: GoIcons.GoFile,
    GoCopy: GoIcons.GoCopy,
    GoLog: GoIcons.GoLog,
    GoPlusCircle: GoIcons.GoPlusCircle,
    GoOrganization: GoIcons.GoOrganization,
    GoNote: GoIcons.GoNote,
    GoCommentDiscussion: GoIcons.GoCommentDiscussion,
    GoPlus: GoIcons.GoPlus,
    GoTable: GoIcons.GoTable,
    GoProject: GoIcons.GoProject,
    GoStack: GoIcons.GoStack,
    GoRepo: GoIcons.GoRepo,
    GoLaw: GoIcons.GoLaw,
    GoHistory: GoIcons.GoHistory,

    // Other Libraries
    CgHello: CgHello,

    // Custom Aliases from your original code
    search: GoIcons.GoBrowser,
    ebarimt: GoIcons.GoReply,
    log: GoIcons.GoLog, // 'log' was an alias for GoLog
    cycle: GoIcons.GoServer, // 'cycle' was an alias for GoServer
    ticket: GoIcons.GoUnread,
    'ticket-create': GoIcons.GoPlusCircle,
    bell: GoIcons.GoBell,
    contract: GoIcons.GoLaw,
    'contract-create': GoIcons.GoPlus,
};

interface IconProps {
    icon: string;
}

/**
 * A dynamic and efficient Icon component.
 * It looks up the requested icon in the `iconMap` and renders it.
 * If the icon is not found, it renders a default 'Question' icon.
 */
const Icon: React.FC<IconProps> = ({ icon }) => {
    // Look up the component in the map. If it doesn't exist, use GoQuestion as the fallback.
    const IconComponent = iconMap[icon] || GoIcons.GoQuestion;

    return <IconComponent />;
};

export default Icon;